
   
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorMessage } from '../models/error-message.model';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  getClientMessage(error: Error | ErrorMessage): ErrorMessage {
    // Uncatched client side error
    if (error instanceof Error) {
      return error.message
        ? { message: error.message }
        : { message: 'An error occurred' };
    } else {
      // Manually triggered ErrorMessage
      // eg. throw { title: 'Error Title', message: 'BODY ERROR' } as ErrorMessage;
      return {
        title: error.title || '',
        message: error.message,
      };
    }
  }

  getServerMessage(error: HttpErrorResponse): ErrorMessage {
    if (error?.error?.message) {
      return {
        title: error.error?.title || '',
        message: error.error.message,
      };
    }

    return { message: 'An error occurred' };
  }
}